import { apiUrl } from "../../../settings"

export const bannersUrl = () => {
  return apiUrl + '/banners'
}


export const dltbannersUrl = (id) => {
    return apiUrl + '/banners/' + id
  }